import type { FC, PropsWithChildren } from "react";
import { useIntl } from "react-intl";
import { MobileNavigationMenuButton } from "../../MobileNavigationMenuButton/MobileNavigationMenuButton";
import { StyledSection } from "../../styled";
import { StyledWrapper } from "./styled";
import "@nectary/components/title";

type MobileNavigationHeaderProps = {
  onClick: () => void;
};
export const MobileNavigationHeader: FC<
  PropsWithChildren<MobileNavigationHeaderProps>
> = ({ children, onClick }) => {
  const intl = useIntl();
  return (
    <StyledWrapper>
      <StyledSection>
        <MobileNavigationMenuButton onClick={onClick}>
          {children}
        </MobileNavigationMenuButton>
      </StyledSection>

      <StyledSection align="center">
        <sinch-title
          type="m"
          level="1"
          text={intl.formatMessage({ id: "menuText" })}
        />
      </StyledSection>
      <StyledSection />
    </StyledWrapper>
  );
};
